import { configureStore, combineReducers } from "@reduxjs/toolkit";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";

import authReducer from "../reducer/authReducer/AuthReducer";
import settingsReducer from "../reducer/settingReducer/SettingReducer";
import userReducer from "../reducer/userReducer/UserReducer";
import supplierReducer from "../reducer/supplierReducer/SupplierReducer";
import requestReducer from "../reducer/requestsReducer/RequestReducer";
import inventoryReducer from "../reducer/inventoryReducer/InventoryReducer";
import dashboardReducer from "../reducer/dashboardReducer/DashboardReducer";
import organizationReducer from "../reducer/organizationReducer/OrganizationReducer";

const authPersistConfig = {
  key: "auth",
  storage,
  whitelist: ["user", "permissions", "isAuthenticated"],
};

const rootReducer = combineReducers({
  auth: persistReducer(authPersistConfig, authReducer),
  settings: settingsReducer,
  user: userReducer,
  supplier: supplierReducer,
  request: requestReducer,
  inventory: inventoryReducer,
  dashboard: dashboardReducer,
  organization: organizationReducer,
});

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ["persist/PERSIST", "persist/REHYDRATE"],
      },
    }),
});

export const persistor = persistStore(store);